import React from 'react';
import styled from 'styled-components';
import { useSocketIOContext } from './';
import { ReadyState } from 'react-use-websocket';

export const WebsocketIndicator = () => {
  const { connected } = useSocketIOContext();

  const getStatusLabel = (): string => {
    switch (connected) {
      case connected:
        return 'Connected';
      case !connected:
        return 'Disconnected';
      default:
        return 'Unknown';
    }
  };

  const getStatusColor = (): string => {
    switch (connected) {
      case connected:
        return '#5ee32c';
      case !connected:
        return '#ff003b';
      default:
        return 'gray';
    }
  };

  return (
    <Container>
      <Indicator $color={getStatusColor()} />
      <Label>
        {getStatusLabel()}
      </Label>
    </Container>
  );
};

const Label = styled.div`
  display: inline-block;
  min-width: 120px;
  font-size: 10px;
  color: white;
  opacity: 0.3;
  white-space: nowrap;
`;

const Indicator = styled.div<{
  $color: string;
}>`
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  opacity: 0.5;
`;

const Container = styled.div`
  position: absolute;
  bottom: 50%;
  right: 1rem;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  transform: translateX(50%) rotate(-90deg) translateY(-50%);
`;
